import { sanitizePlacementId } from '../utils/recommendationsUtils';

export const SAVE_RR = 'SAVE_RR';
export const RR_ERROR = 'RR_ERROR';

export function saveRR(RRresponse, placement, strategyName, tileTemplate, isDy = false, feedId = null, widgetId = null, seeMoreUrl = null) {
    return {
        type: SAVE_RR,
        payload: {
            placementKey: sanitizePlacementId(placement),
            recs: RRresponse,
            placement: placement,
            strategyName: strategyName,
            tileTemplate: tileTemplate,
            isDy: isDy,
            feedId: feedId,
            widgetId: widgetId,
            seeMoreUrl: seeMoreUrl
        }
    };
}

export function rrError(message, location) {
    return {
        type: RR_ERROR,
        error: {
            message: message,
            location: location
        }
    };
}
